import { render, staticRenderFns } from "./ProjectDetailPage.vue?vue&type=template&id=c9615860&scoped=true&lang=pug&"
import script from "./ProjectDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9615860",
  null
  
)

export default component.exports